export default "__VITE_ASSET__CbcV5ky2__"